import type { FaireProductEntity } from "../../entity_types/product";

export const p_4kq9rh396f: FaireProductEntity = {
  token: "p_4kq9rh396f",
  type: "product",
  name: "Game Day Mascot Beaded Dangle & Drop Earrings",
  brandToken: "b_vswk7rntc2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4803e8d1738461bf60b7c6d2ecc86bf5b7b94ab8489c9861352faf4775c35123.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8c37e6efae85c2f08af91fe1d11e53d00b9fe34abe889e06bcd0fd6a2039c04.jpeg",
  ],
  priceDollars: 16.46,
  description:
    'Sport these Wild Red Mascot Earrings on your next Game Day! \n\nHEIGHT: 2.25" WIDTH: 2.25" \n\nRED WILD PIG BOAR SPORTS GAMED DAY ATHLETIC TEAM COLORS SPORT FAN COLLEGE COLLEGIATE SPORTS SEED BEAD EMBELLISHED HANDMADE HANDCRAFTED DANGLE DROP EARRINGS',
  tags: [],
  msrpDollars: 32.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:29:31.756Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
